<template>
  <div style="width: 100%">
    <!-- <b-card header-tag="header" style="height: 300px;" body-class="card-body"> -->
    <!-- <template v-slot:header>
        <b-row>
          <b-col cols="7">
            <h3 class="mb-0">{{ tool.text }}</h3>
          </b-col>
          <b-col>
            <b-button-group v-if="focus.state == 'ontrack'">
              <b-button
                @click="showTracking = false"
                :active="!showTracking"
                :pressed="!showTracking"
              >
                <i class="fa fa-wrench"></i>
              </b-button>
              <b-button
                class="mr-1"
                @click="showTracking = true"
                :active="showTracking"
                :pressed="showTracking"
              >
                <i class="fa fa-bar-chart"></i>
              </b-button>
            </b-button-group>
          </b-col>
        </b-row>
      </template> -->
    <!-- <journal-web-component :id="`${getToolMasterData(tool.tools_id).tooldetail.toolId}_${tool.tools_id}`" /> -->
    <component
      :idprop="
        this.isTrack
          ? `${getToolMasterData(tool.toolId).tooldetail.toolId}_${user.uid}`
          : `${getToolMasterData(tool.tools_id).tooldetail.toolId}_${
              tool.tools_id
            }`
      "
      v-bind="
        Object.assign(
          { tool: tool },
          { focus: focus },
          { user: user },
          { showTracking: showTracking }
        )
      "
      :is="toolwindow(tool.tools_id ? tool.tools_id : tool.toolId)"
      :isTrack="this.isTrack"
      :ref="tool.text ? tool.text : tool.toolObj && tool.toolObj.text"
      @saveVideosToAT="saveVideosToAT"
    >
      <slot v-if="focus.state == 'ontrack'" name="ontrack">
        <b-container> </b-container>
      </slot>
      <slot v-else-if="focus.state == 'ondeck'" name="ondeck">
        <b-container> </b-container>
      </slot>
      <slot v-else-if="focus.state == 'stationed'" name="stationed">
        <b-container> </b-container>
      </slot>
      <slot v-else-if="focus.state == 'join'" name="join">
        <b-container> </b-container>
      </slot>
      <slot v-else name="maintenance">
        <b-container> </b-container>
      </slot>
    </component>
    <!-- </b-card> -->
    <!-- SHOW THE TOOL SELECTION -->
    <!-- <b-modal
      @show="showModalAppStore"
      centered
      hide-header
      hide-footer
      title="BootstrapVue"
      style="background-color: black"
      body-bg-variant="dark"
    >
      <slot name="tool"> </slot>
    </b-modal> -->
  </div>
</template>
<script>
// import toolconfig from './toolconfig.json'
// import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
// import LineChart from '../_charts/LineChart/index'
// import BarChart from '../_charts/BarChart/index'
// import Default from '../default'

// import Timer from "../../../../_developer/tools/timer";
import Timer from "../../../../myjourneybinder-web-components/src/components/Timer";
import Journal from "../../../../myjourneybinder-web-components/src/components/Journal";
import Checkin from "../../../../myjourneybinder-web-components/src/components/Checkin";
import Calculator from "../../../../myjourneybinder-web-components/src/components/Calculator";
// import YouTubeViewer from "../../../../_developer/tools/youtubeviewer";
import YouTubeViewer from "../../../../myjourneybinder-web-components/src/components/YoutubeViewer";
import Emote from "../../../../myjourneybinder-web-components/src/components/Emote";
import Measure from "../../../../myjourneybinder-web-components/src/components/Measure";
import Freight from "../../../../myjourneybinder-web-components/src/components/Freight";
import Envision from "../../../../_developer/tools/envision";
import Quotable from "../../../../_developer/tools/quotable";
import ToDone from "../../../../_developer/tools/todone";
import Skills from "../../../../_developer/tools/skills";
import Budget from "../../../../_developer/tools/budget";
import Boarded from "../../../../_developer/tools/boarded";
import NextStep from "../../../../_developer/tools/nextstep";

export default {
  name: "base-web-component",
  components: {
    // VueBootstrapTypeahead,
    // timer,
    // LineChart,
    // BarChart
    // 'tool-default': Default,
    "tool-checkin": Checkin,
    "tool-journal": Journal,
    "tool-timer": Timer,
    "tool-calculator": Calculator,
    "tool-youtubeviewer": YouTubeViewer,
    "tool-emote": Emote,
    "tool-measure": Measure,
    "tool-freight": Freight,
    "tool-envision": Envision,
    "tool-quotable": Quotable,
    "tool-todone": ToDone,
    "tool-skills": Skills,
    "tool-budget": Budget,
    "tool-boarded": Boarded,
    "tool-nextstep": NextStep
  },
  props: {
    tool: {
      type: Object,
      required: false,
      default: () => {}
    },
    focus: {
      type: Object,
      required: false,
      default: () => {}
    },
    user: {
      type: Object,
      required: false,
      default: () => {}
    },
    typeaheadApps: {
      type: Array,
      default: () => ["Maps", "Calculator"]
    },
    userid: {
      type: String
    },
    isTrack: {
      type: Boolean,
      default: () => false
    }
  },
  methods: {
    saveVideosToAT(videos) {
      this.$emit("saveVideosToAT", videos);
    },
    setSettings() {
      this.showModalAppStore = true;
    },
    setPlan() {
      this.showModalAppStore = true;
    },
    setTracks() {
      this.showModalAppStore = true;
    },
    fillData() {
      this.datacollection = {
        labels: [this.getRandomInt(), this.getRandomInt()],
        datasets: [
          {
            label: "Data One",
            backgroundColor: "#f87979",
            data: [this.getRandomInt(), this.getRandomInt()]
          },
          {
            label: "Data One",
            backgroundColor: "#f87979",
            data: [this.getRandomInt(), this.getRandomInt()]
          }
        ]
      };
    },
    getRandomInt() {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5;
    },
    toolwindow(tool_id) {
      let tool = this.getToolMasterData(tool_id);
      console.log("getToolMasterData", tool);
      if (tool && tool.tooldetail) {
        switch (tool.tooldetail.toolId) {
          case "3NMwypL36jf2c3lZd5tv":
            return "tool-default";
          case "CfwizkXidsgV9kCWTl6W":
            return "tool-youtubeviewer";
          //added by b meeran
          case "oDCp614v2vbidCSmFRsC":
            return "tool-youtubeviewer";
          //
          case "NO7EQurDDUGpFEXahVyc":
            return "tool-emote";
          case "Vd4znYuokX1KjI6m1aaJ":
            return "tool-calculator";
          case `lgEFZme4exZpDhd4qoEC`:
            return "tool-measure";
          case `BWD2yYfW9dtDRJHDTuhs`:
            return "tool-freight";
          case `Xe4LIcncei9h1Onkx1DI`:
            return "tool-checkin";
          case `8XOINrQ114DOsK1myLqi`:
            return "tool-journal";
          case `MsSmZzdX8A0bYRhw924M`:
            return "tool-timer";
          case `X3cYjJG2cy6AEAw5JcAA`:
            return "tool-envision";
          case `kOAhlnC8OpFewC40I0AP`:
            return "tool-quotable";
          case `WNiLRFwO52A6FcF1bLRq`:
            return "tool-todone";
          case `K0id7mrn2QaW2hrHqQzg`:
            return "tool-skills";
          case `eBdEDITNCrXki5Ad6KHX`:
            return "tool-budget";
          case `2C18DKcnectg1kQ60UCX`:
            return "tool-boarded";
          case `ZR7d5feR2uCSg6NUsd8X`:
            return "tool-nextstep";
          default:
            return "tool-skills";
        }
        //   switch (tool.tooldetail.toolId) {
        //     case "3NMwypL36jf2c3lZd5tv":
        //       return "tool-default";
        //     case "oDCp614v2vbidCSmFRsC":
        //       return "tool-youtubeviewer";
        //     case "BBOLdv1zr3jBGLpH3tyC":
        //       return "tool-emote";
        //     case "uxSYDzXJaYMMJdGQm0qQ":
        //       return "tool-calculator";
        //     case `PP7B6SZ5sHGByBsHDHfY`:
        //       return "tool-measure";
        //     case `GUSafHLbpRZ1jrRWssip`:
        //       return "tool-freight";
        //     case `R9fcNzGEAex99CLFc16M`:
        //       return "tool-checkin";
        //     case `vTbh43Oxz2D1PjIBvGXw`:
        //       return "tool-journal";
        //     case `BzYtKyLYkhQLUPY4Pxv5`:
        //       return "tool-timer";
        //     default:
        // return "tool-default";
        //   }
      }
    },
    getToolMasterData(uid) {
      console.log("Tool Master Data: uid", uid);
      let tools;
      if (!this.userid) {
        tools = this.$store.getters["user/listTools"];
      } else {
        tools = this.$store.getters["user/joinTools"][this.userid];
      }
      console.log("meeran", tools);
      let tool = tools.filter(el => {
        if (
          el.uid === uid ||
          (el && el.tooldetail && el.tooldetail.toolId == uid)
        ) {
          if (el && el.tooldetail && el.tooldetail.name) {
            return el;
          }
        }
      });
      if (tool[0] && tool[0].tooldetail) {
        return tool[0];
      } else {
        return null;
      }
    }
  },
  computed: {},
  data: function() {
    return {
      showTracking: false,
      showModalAppStore: false,
      // timer needs
      datacollection: null
    };
  },
  mounted() {
    console.log("Toool ", this.tool);
    this.fillData();
  }
};
</script>
<style lang="scss" module>
@import "./style.module.scss";
</style>
<style scoped>
.card-body {
  overflow-y: auto;
}
</style>
